function phoneMask(value) {
  let len;
  let val;
  let result;
  if (value) {
    val = value.toString().replace(/\D/g, '');
    len = val.length;

    if (len <= 3) {
      result = val;
    }
    if (len > 3 && len < 7) {
      result = `(${val.substr(0, 3)}) ${val.substr(3)}`;
    }
    if (len > 6) {
      result = `(${val.substr(0, 3)}) ${val.substr(3, 3)}-${val.substr(6)}`;
    }
  }

  return result;
}
export default phoneMask;
